export default __webpack_public_path__ + "static/media/apocalypse.f2c339f7.mp3";